import * as React from 'react'
import Whirligig from 'react-whirligig';
import ASK1 from './images/t1.png';
import ASK2 from './images/t2.png';
import ASK3 from './images/t3.png';
import ASK4 from './images/t4.png';
import ASK5 from './images/t5.png';
import ASK6 from './images/t6.png';
import ASK7 from './images/t7.png';
import STAR from './images/star.png';
import './css/OnlineTeachersSlider.scss';
import {
    isMobileOnly,
    isTablet
} from "react-device-detect";

const OnlineTeachersSlider = () => {

    let height,visibleSlides;

    if(isMobileOnly){
        height="230px";
        visibleSlides=1.3;
    }
    else if(isTablet){
        height="350px";
        visibleSlides=1.3;
    }

    return (
        <div className="container mt-5 mb-5 OnlineTeachersSlider">
            <p className="Tutors-for-every-kind-of-learner">Tutors for every kind of learner</p>
            <div>
                <Whirligig
                    slideBy={1}
                    visibleSlides={visibleSlides}
                >
                    <div className="card coloumn mb-4">
                        <img className="image" src={ASK4} alt="ASK4" style={{height:height}}></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img className="image" src={ASK5} alt="ASK5" style={{height:height}}></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img className="image" src={ASK6} alt="ASK6" style={{height:height}}></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img className="image" src={ASK7} alt="ASK7" style={{height:height}}></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img className="image" src={ASK1} alt="ASK1" style={{height:height}}></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img className="image" src={ASK2} alt="ASK2" style={{height:height}}></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img className="image" src={ASK3} alt="ASK3" style={{height:height}}></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                        </div>
                    </div>
                    <div className="card coloumn">
                        <img className="image" src={ASK4} alt="ASK4" style={{height:height}}></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                </Whirligig>
            </div>
            <p className="Show-all-online-tutors"><b>Show all online tutors</b> &gt;</p>
        </div>
    )
}

export default OnlineTeachersSlider;